module.exports = __webpack_public_path__ + "img/Réalisation portail sur mesure alu avec découpe laser.23686e7c.jpg";